import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Verification from "./Verification";
import BasicInfo from "./BasicInfo";
import Plans from "./Plans";
import FamilyInfo from "./FamilyInfo";
import HealthInfo from "./HealthInfo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Payment from "./Payment";
import BasicInfoN from "../../images/BasicInfo.png";
import Family from "../../images/Familuy.png";
import Health from "../../images/health.png";
import VerificationN from "../../images/Verification.png";
import PlansN from "../../images/Plans.png";
import PaymentN from "../../images/Payment.png";
import walletblue from "../../images/walletblue.svg";
import Familyblue from "../../images/Family blue.svg";
import healthblue from "../../images/healthblue.svg";
import Plansblue from "../../images/Plansblue.svg";
import BasicInfoblue from "../../images/BasicInfoblue.svg";
import Verificationblue from "../../images/Verificationblue.svg";
import {
  addB2CCustomerDetails,
  getActiveRetailPlanAndPricingList,
} from "../../services/login";

import Footer from "../Footer";
import { toast } from "react-toastify";

import { useLocation, useNavigate } from "react-router-dom";
import { RegisterB2CCustomerDetails } from "../../services/customerOnboarding";

const Landing = () => {
  const steppers = [
    "Basic Info",
    "Verification",
    "Plans",
    "Family Info",
    "Health Info",
    "Payment",
  ];

  const stepsDesc = [
    {
      step: "Eligibility Check",
      desc: "Verify service availability in your area using a pin code to ensure you can access our insurance services.",
    },

    {
      step: "Mobile Verification",
      desc: "Secure your account by confirming your mobile number with a OTP and providing your name.",
    },

    {
      step: "Plan Selection",
      desc: "Choose the insurance plan that best fits your needs from a selection of five different options.",
    },

    {
      step: "Member Details",
      desc: "Provide the names, dates of birth, and relationships of all individuals for whom the insurance is being purchased.",
    },

    {
      step: "Health Assessment",
      desc: "Fill out essential health information for each covered member to customize the policy.",
    },

    {
      step: "Payment",
      desc: "Complete your insurance purchase securely and conveniently by making the required payment.",
    },
  ];

  const stepperImage = [
    { name: "Basic Info", image: BasicInfoN, imageSelected: BasicInfoblue },
    {
      name: "Verification",
      image: VerificationN,
      imageSelected: Verificationblue,
    },
    { name: "Plans", image: PlansN, imageSelected: Plansblue },
    { name: "Family Info", image: Family, imageSelected: Familyblue },
    { name: "Health Info", image: Health, imageSelected: healthblue },
    { name: "Payment", image: PaymentN, imageSelected: walletblue },
  ];

  const [selected, setSelected] = React.useState("Basic Info");
  const [plan, setPlan] = React.useState();
  const [pincode, setPincode] = React.useState();
  const [number, setNumber] = React.useState();
  const [oTP, setOTP] = React.useState();
  const [payment, setPayment] = React.useState();
  const [plantype, setPlanType] = React.useState();
  const [familyPlans, setFamilyPlans] = React.useState();
  const [indivisualPlans, setIndivisualPlansPlans] = React.useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("token"));
  const location = useLocation();
  console.log("indivisualPlans: ", indivisualPlans);

  const [duration, setDuration] = React.useState(1);
  console.log("plan: ", plan);
  const [familyInfo, setFamilyInfo] = React.useState([
    { relation: "Self", name: "", dob: "", gender: "" },
    { relation: "", name: "", dob: "", gender: "" },
    { relation: "", name: "", dob: "", gender: "" },
  ]);

  useEffect(() => {
    plantype === "Indivisual"
      ? setFamilyInfo([{ relation: "Self", name: "", dob: "", gender: "" }])
      : setFamilyInfo([
          { relation: "Self", name: "", dob: "", gender: "" },
          { relation: "", name: "", dob: "", gender: "" },
          { relation: "", name: "", dob: "", gender: "" },
        ]);
  }, [plantype]);

  console.log("familyInfo: ", familyInfo);
  const [health, setHealth] = React.useState([]);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [name, setName] = React.useState();
  const [email, setEmail] = React.useState();

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  async function getPlanDetails() {
    const { data } = await getActiveRetailPlanAndPricingList();
    console.log("data: ", data);
    if (data) {
      const indivisual = data.filter((item) => item.planType === "Individual");
      console.log("indivisual: ", indivisual);
      const family = data.filter((item) => item.planType === "Family");
      console.log("family: ", family);
      setIndivisualPlansPlans(indivisual);
      setFamilyPlans(family);
    }
  }

  React.useEffect(() => {
    getPlanDetails();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const selectedIndex = steppers.indexOf(selected);
  console.log("selectedIndex: ", selectedIndex);

  const submitToProceed = async () => {
    const noOfMembers = parseInt(familyInfo?.length);
    const pricePerYear = parseInt(plan?.planDiscountPrice) * 12;
    const totalPrice = noOfMembers * pricePerYear * parseInt(duration);
    const taxes = (totalPrice * 18) / 100; // 18% tax
    const total = totalPrice + taxes; // Total including taxes

    const formattedTaxes = parseFloat(taxes.toFixed(2));
    const formattedTotal = parseFloat(total.toFixed(2));

    console.log("Health", health);
    const val = {
      name: name,
      pincode: pincode,
      number: number,
      email: email,
      planUniqueId: plan?.uniqueId,
      duration: duration,
      pricePerPerson: pricePerYear,
      noOfMembers: noOfMembers,
      totalPrice: totalPrice,
      discount: 0,
      taxes: formattedTaxes,
      total: formattedTotal,
      b2cCustomerMemberDetailsRequest: health,
    };
    try {
      if (token?.designation === "Customer Support Executive") {
        setIsSubmitting(true);
        const { data } = await RegisterB2CCustomerDetails(val);
        if (data) {
          toast.success("Registered Successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          const id = data;
          if (id) {
            setTimeout(() => {
              navigate(`/user/viewRetailCustomerdetails/${id}`);
            }, 1500);
          }
        }
      } else {
        setIsSubmitting(true);
        const { data } = await addB2CCustomerDetails(val);
        console.log("data: ", data);
        if (data) {
          alert(
            "Proceeding to Payment Screen. Don't Click back button until finish the payment."
          );
          window.location.href =
            data?.data?.instrumentResponse?.redirectInfo?.url;
        }
      }
    } catch (e) {
      console.log(e);
      setIsSubmitting(false);
      toast.error("Payment Initiation Failed. Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  // const showNavbar =
  //   location.pathname === "/enrollInPlan" ||
  //   token?.designation !== "Customer Support Executive";

  const showNavbar = !(
    location.pathname === "/user/enrollInPlan" &&
    (token?.designation === "Customer Support Executive" ||
      token?.role === "Admin")
  );

  const backgroundStyle =
    location.pathname === "/enrollInPlan"
      ? "linear-gradient(150deg, #2d0969, #100344)"
      : location.pathname === "/user/enrollInPlan" &&
        token?.designation === "Customer Support Executive"
      ? "transparent"
      : token?.designation === "Customer Support Executive"
      ? "transparent"
      : token?.role === "Admin"
      ? "transparent"
      : "linear-gradient(150deg, #2d0969, #100344)";

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [selected]);

  return (
    <div
      className="b2ccontent"
      style={{
        background: backgroundStyle,
      }}
    >
      {showNavbar && <Navbar />}
      <div
        style={{
          // backgroundColor: "#1A0655",
          // minHeight: "100vh",
          // padding:
          //   width > 786 && token?.designation !== "Customer Support Executive"
          //     ? "100px 200px 0px 200px"
          //     : "80px 10px 0px 10px",
          padding:
            (token?.designation === "Customer Support Executive" ||
              token?.role === "Admin") &&
            location.pathname === "/user/enrollInPlan"
              ? "0px"
              : location.pathname === "/enrollInPlan"
              ? window.innerWidth > 600
                ? "100px 200px 0px 200px"
                : "80px 10px 0px 10px"
              : window.innerWidth > 786
              ? "100px 200px 0px 200px"
              : "80px 10px 0px 10px",
        }}
        className="myFont"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {stepperImage.map((item, index) => (
                <Grid key={index} item xs={2}>
                  <div
                    style={{
                      backgroundColor:
                        selectedIndex >= index ? "#D83F87" : "#fff",
                      textAlign: "center",
                      padding: selectedIndex === index ? "20px" : "15px",
                      borderRadius: "8px",
                      maxWidth: window.innerWidth > 786 ? "80px" : "30px",
                      // width: width > "600px" ? "80px" : "30px",
                    }}
                  >
                    <img
                      style={{
                        height: width > 786 ? "80%" : "100%",
                        width: width > 786 ? "80%" : "100%",
                      }}
                      src={
                        selected === item.name
                          ? item?.image
                          : item?.imageSelected
                      }
                      alt="Header Images"
                    ></img>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <div style={{ display: "flex", borderRadius: "12px" }}>
              <div
                style={{
                  backgroundColor: "#D83F87",
                  padding: "15px",
                  textAlign: "center",
                  borderRadius: "12px 0px 0px 12px",
                }}
              >
                <Typography variant="h6" sx={{ color: "#fff" }}>
                  {selectedIndex + 1}
                </Typography>
              </div>
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "10px 10px 5px 15px",
                  borderRadius: "0px 12px 12px 0px",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#D83F87", fontWeight: "bold" }}
                >
                  {stepsDesc[selectedIndex].step}
                </Typography>
                <Typography variant="subtitle2" sx={{ color: "#434343" }}>
                  <i>{stepsDesc[selectedIndex].desc}</i>
                </Typography>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} lg={11} p={width > 786 ? "5" : "1"}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              {selected === "Basic Info" && (
                <BasicInfo
                  selected={selected}
                  setSelected={setSelected}
                  pincode={pincode}
                  setPincode={setPincode}
                  name={name}
                  setName={setName}
                  email={email}
                  setEmail={setEmail}
                />
              )}
              {selected === "Verification" && (
                <Verification
                  selected={selected}
                  setSelected={setSelected}
                  number={number}
                  setNumber={setNumber}
                  oTP={oTP}
                  setOTP={setOTP}
                  setFamilyInfo={setFamilyInfo}
                  setHealth={setHealth}
                />
              )}
              {selected === "Plans" && (
                <Plans
                  selected={selected}
                  setSelected={setSelected}
                  plan={plan}
                  setPlan={setPlan}
                  setPlanType={setPlanType}
                  indivisualPlans={indivisualPlans}
                  familyPlans={familyPlans}
                  number={number}
                />
              )}
              {selected === "Family Info" && (
                <FamilyInfo
                  selected={selected}
                  setSelected={setSelected}
                  familyInfo={familyInfo}
                  width={width}
                  setFamilyInfo={setFamilyInfo}
                  planType={plantype}
                />
              )}
              {selected === "Health Info" && (
                <HealthInfo
                  selected={selected}
                  setSelected={setSelected}
                  health={health}
                  setHealth={setHealth}
                  familyInfo={familyInfo}
                />
              )}
              {selected === "Payment" && (
                <Payment
                  selected={selected}
                  setSelected={setSelected}
                  plan={plan}
                  duration={duration}
                  setDuration={setDuration}
                  familyInfo={familyInfo}
                  submitToProceed={submitToProceed}
                  setPayment={setPayment}
                  isSubmitting={isSubmitting}
                />
              )}
            </LocalizationProvider>
          </Grid>
        </Grid>
      </div>
      {showNavbar && <Footer />}
    </div>
  );
};

export default Landing;
